export const CATEGORY_CHOICES = {
  CALCULATIONS: 'calculations',
  DRAFT: 'draft',
  VAT_RETURN: 'vat_return',
  SUPPORTING_DOCUMENT: 'supporting_document',
  SUBMITTED_FILING: 'submitted_filing',
  PROOF_PAYMENT: 'proof_payment',
  PRE_CONVERSION: 'pre_conversion',
  POST_CONVERSION: 'post_conversion',
  GAME_CHANGER_OUTPUT: 'gameChangerOutput',
  ONLINE_SPREADSHEET: 'onlineSpreadsheet',
} as const;
